
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { MdContentCopy } from "react-icons/md";
// import { toast } from 'react-toastify'; // Import toast

// // Import CSS files
// import "../../Dashboard Style/core.css";
// import "../../Dashboard Style/flatpickr.min.css";
// import "../../assets1/css/custom.css";
// import "../../assets1/css/style.css";

// // Import images
// import logo from "../../assets1/images/logo.webp";
// import usFlag from "../../assets1/images/flags/us.svg";
// import frFlag from "../../assets1/images/flags/fr.svg";
// import face2 from "../../assets1/images/faces/face2.webp";
// import face3 from "../../assets1/images/faces/face3.webp";

// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';

// const PaymentReport = () => {
//   const navigate = useNavigate();
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);
//   const [openDropdowns, setOpenDropdowns] = useState({});
//   const [paymentReports, setPaymentReports] = useState([]);
//   const [filters, setFilters] = useState({
//     date: "",
//     month: "",
//     year: ""
//   });
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [totalCount, setTotalCount] = useState(0);
//   const [copiedId, setCopiedId] = useState(null);

//   // Add toggle sidebar function
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');

//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }

//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     const initialDropdownState = {
//       dashboard: false,
//       fundManagement: false,
//       registrationTeam: false,
//       incomeEarnings: false,
//       bonanzaRewards: false,
//       airdrop: false,
//       withdrawal: false,
//       settings: false
//     };
//     setOpenDropdowns(initialDropdownState);

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }

//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }

//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }

//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }

//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }

//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }

//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }

//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }

//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }

//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }

//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }

//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }

//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }

//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }

//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }

//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }

//       /* Copy button styles */
//       .copy-btn {
//         transition: all 0.2s ease;
//         opacity: 0.7;
//       }

//       .copy-btn:hover {
//         opacity: 1;
//         transform: scale(1.1);
//       }

//       /* Tooltip for copy feedback */
//       .copy-tooltip {
//         position: absolute;
//         top: -30px;
//         left: 50%;
//         transform: translateX(-50%);
//         background: #28a745;
//         color: white;
//         padding: 4px 8px;
//         border-radius: 4px;
//         font-size: 12px;
//         white-space: nowrap;
//         z-index: 1000;
//         animation: fadeInOut 2s ease;
//       }

//       .copy-tooltip:after {
//         content: '';
//         position: absolute;
//         bottom: -5px;
//         left: 50%;
//         transform: translateX(-50%);
//         border-left: 5px solid transparent;
//         border-right: 5px solid transparent;
//         border-top: 5px solid #28a745;
//       }

//       @keyframes fadeInOut {
//         0% { opacity: 0; transform: translateX(-50%) translateY(5px); }
//         20% { opacity: 1; transform: translateX(-50%) translateY(0); }
//         80% { opacity: 1; transform: translateX(-50%) translateY(0); }
//         100% { opacity: 0; transform: translateX(-50%) translateY(-5px); }
//       }

//       /* Make hash text selectable and clickable */
//       .hash-text {
//         cursor: pointer;
//         transition: color 0.2s ease;
//         user-select: none;
//       }

//       .hash-text:hover {
//         color: #007bff !important;
//       }

//       /* Responsive adjustments for table */
//       @media (max-width: 768px) {
//         .table-responsive {
//           font-size: 14px;
//         }

//         .copy-btn {
//           padding: 2px !important;
//           min-width: 20px !important;
//           min-height: 20px !important;
//         }
//       }
//     `;
//     document.head.appendChild(style);

//     // Load payment reports
//     fetchPaymentReports();

//     // Initialize Lucide icons
//     if (window.lucide) {
//       window.lucide.createIcons();
//     }

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   // Toggle dropdown function
//   const toggleDropdown = (key) => {
//     setOpenDropdowns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const fetchPaymentReports = async (filterParams = {}) => {
//     setIsLoading(true);

//     try {
//       const queryParams = new URLSearchParams();

//       if (filterParams.date) {
//         queryParams.append('date', filterParams.date);
//       }
//       if (filterParams.month) {
//         queryParams.append('month', filterParams.month);
//       }
//       if (filterParams.year) {
//         queryParams.append('year', filterParams.year);
//       }

//       const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

//       const response = await fetch(
//         `https://global.thewillowquantum.com/api/user/get-register-payment-list${queryString}`,
//         {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${authToken}`,
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           }
//         }
//       );

//       if (response.status === 401) {
//         toast.error("Session expired. Please log in again.");
//         navigate('/signin');
//         return;
//       }

//       const result = await response.json();

//       if (result.status) {
//         const transformedData = result.data.map(item => ({
//           id: item.id,
//           paymentMode: item.payment_mode,
//           paymentHash: item.payment_hash_id,
//           paymentAmount: item.payment_amount,
//           paymentReceiveHash: item.payment_receive_hash_id,
//           paymentStatus: item.payment_status,
//           paymentComment: item.payment_comment,
//           statusUpdateAt: item.payment_status_update_at,
//           createdAt: item.created_at,
//           firstName: "User",
//           lastName: "",
//           accountName: item.payment_receive_hash_id ? item.payment_receive_hash_id.substring(0, 8) : "N/A",
//           mobile: "N/A",
//           country: "N/A",
//           submissionDate: item.created_at,
//           approvalDate: item.payment_status === "Approved" ? item.payment_status_update_at : null,
//           status: item.payment_status
//         }));

//         setPaymentReports(transformedData);

//         const totalAmt = transformedData.reduce((sum, item) => sum + item.paymentAmount, 0);
//         setTotalAmount(totalAmt);
//         setTotalCount(transformedData.length);

//         toast.success("Payment reports loaded successfully!");
//       } else {
//         toast.error(result.message || "Failed to load payment reports");
//       }
//     } catch (error) {
//       console.error("Error fetching payment reports:", error);
//       toast.error("Network error. Please check your connection.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     fetchPaymentReports(filters);
//   };

//   const clearFilters = () => {
//     setFilters({
//       date: "",
//       month: "",
//       year: ""
//     });
//     fetchPaymentReports();
//   };

//   const exportToExcel = () => {
//     if (paymentReports.length === 0) {
//       toast.warning("No data to export");
//       return;
//     }

//     const exportData = paymentReports.map(report => ({
//       'ID': report.id,
//       'Payment Mode': report.paymentMode,
//       'Payment Hash ID': report.paymentHash,
//       'Payment Amount': `$${report.paymentAmount}`,
//       'Receiver Hash ID': report.paymentReceiveHash,
//       'Status': report.paymentStatus,
//       'Comment': report.paymentComment || 'N/A',
//       'Created At': report.createdAt,
//       'Status Updated At': report.statusUpdateAt || 'N/A'
//     }));

//     const csvContent = "data:text/csv;charset=utf-8,"
//       + [Object.keys(exportData[0]).join(",")]
//         .concat(exportData.map(row => Object.values(row).map(value =>
//           `"${value}"`).join(",")))
//         .join("\n");

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `payment-reports-${new Date().toISOString().split('T')[0]}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     toast.success("Report exported to CSV successfully!");
//   };

//   const exportToPDF = () => {
//     if (paymentReports.length === 0) {
//       toast.warning("No data to export");
//       return;
//     }

//     toast.info("PDF export feature coming soon!");
//   };

//   // Enhanced copy function with tooltip feedback
//   const copyToClipboard = (text, fieldName = "text", id = null) => {
//     if (!text) {
//       toast.warning(`No ${fieldName} to copy`);
//       return;
//     }

//     navigator.clipboard.writeText(text)
//       .then(() => {
//         // Show temporary tooltip
//         if (id) {
//           setCopiedId(id);
//           setTimeout(() => setCopiedId(null), 2000);
//         }
//         toast.success(`${fieldName} copied to clipboard!`);
//       })
//       .catch(err => {
//         console.error('Failed to copy: ', err);
//         toast.error("Failed to copy to clipboard");
//       });
//   };

//   // Format text for display
//   const formatText = (text, maxLength = 20) => {
//     if (!text) return 'N/A';
//     if (text.length <= maxLength) return text;
//     return `${text.substring(0, maxLength)}...`;
//   };

//   // Function to format date
//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleString();
//   };

//   // Function to get status badge class
//   const getStatusBadgeClass = (status) => {
//     switch (status) {
//       case 'Approved':
//         return 'bg-success';
//       case 'Pending':
//         return 'bg-warning text-dark';
//       case 'Rejected':
//       case 'Failed':
//         return 'bg-danger';
//       default:
//         return 'bg-secondary';
//     }
//   };

//   return (
//     <div className="main-wrapper">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>

//          <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//        <Navbar toggleSidebar={toggleSidebar} />

//         {/* Page Content */}
//         <div className="page-content container-xxl">
//           {/* Page Header */}
//           <div className="row mb-4">
//             <div className="col-12">
//               <div>
//                 <h4 className="fw-bold mb-1">
//                   <i className="me-2" data-lucide="file-text"></i>
//                   Payment Reports
//                 </h4>
//                 <p >View and manage all registration payments</p>
//               </div>
//             </div>
//           </div>

//           {/* Payment Reports Card */}
//           <div className="row">
//             <div className="col-12">
//               <div className="card custom-card">
//                 <div className="top-left"></div>
//                 <div className="top-right"></div>
//                 <div className="bottom-left"></div>
//                 <div className="bottom-right"></div>
//                 <div className="card-body">
//                   <div className="d-flex justify-content-between align-items-baseline mb-3">
//                     <h6 className="card-title mb-0">
//                       <i className="me-2" data-lucide="file-text"></i>
//                       Registration Payment List
//                     </h6>
//                     {isLoading && (
//                       <div className="spinner-border spinner-border-sm text-primary" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                     )}
//                   </div>

//                   <div className="table-responsive">
//                     <table className="table table-hover">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Payment Mode</th>
//                           <th>Payment Hash ID</th>
//                           <th>Payment Amount</th>
//                           <th>Receiver Hash ID</th>
//                           <th>Status</th>
//                           <th>Created At</th>
//                           <th>Updated At</th>
//                           <th>Comment</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {isLoading ? (
//                           <tr>
//                             <td colSpan="9" className="text-center py-5">
//                               <div className="spinner-border text-primary" role="status">
//                                 <span className="visually-hidden">Loading...</span>
//                               </div>
//                               <p className="mt-2 ">Loading payment reports...</p>
//                             </td>
//                           </tr>
//                         ) : paymentReports.length > 0 ? (
//                           paymentReports.map((report, index) => {
//                             const paymentHashId = `payment-${report.id}`;
//                             const receiverHashId = `receiver-${report.id}`;

//                             return (
//                               <tr key={report.id}>
//                                 <td>{index + 1}</td>
//                                 <td>
//                                   <span className="badge bg-warning text-dark">
//                                     {report.paymentMode}
//                                   </span>
//                                 </td>

//                                 {/* Payment Hash ID with Copy Button */}
//                                 <td>
//                                   <div className="d-flex align-items-center gap-2 position-relative">
//                                     <small 
//                                       className=" hash-text" 
//                                       title={report.paymentHash || 'N/A'}
//                                       style={{ 
//                                         wordBreak: 'break-all',
//                                         flex: 1,
//                                         color: "white"
//                                       }}
//                                       onClick={() => copyToClipboard(report.paymentHash, "Payment Hash ID", paymentHashId)}
//                                     >
//                                       {formatText(report.paymentHash, 15)}
//                                     </small>
//                                     <div className="position-relative">
//                                       <button
//                                         className="btn btn-sm btn-outline-secondary p-1 copy-btn"
//                                         onClick={() => copyToClipboard(report.paymentHash, "Payment Hash ID", paymentHashId)}
//                                         title="Copy Payment Hash ID"
//                                         style={{ 
//                                           minWidth: '24px',
//                                           minHeight: '24px',
//                                           display: 'flex',
//                                           alignItems: 'center',
//                                           justifyContent: 'center'
//                                         }}
//                                       >
//                                         <MdContentCopy size={14} />
//                                       </button>
//                                       {copiedId === paymentHashId && (
//                                         <div className="copy-tooltip">
//                                           Copied!
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </td>

//                                 <td>
//                                   <strong>${report.paymentAmount}</strong>
//                                 </td>

//                                 {/* Receiver Hash ID with Copy Button */}
//                                 <td>
//                                   <div className="d-flex align-items-center gap-2 position-relative">
//                                     <small 
//                                       className="hash-text" 
//                                       title={report.paymentReceiveHash || 'N/A'}
//                                       style={{ 
//                                         wordBreak: 'break-all',
//                                         flex: 1,
//                                          color: "white"
//                                       }}
//                                       onClick={() => copyToClipboard(report.paymentReceiveHash, "Receiver Hash ID", receiverHashId)}
//                                     >
//                                       {formatText(report.paymentReceiveHash, 15)}
//                                     </small>
//                                     <div className="position-relative">
//                                       <button
//                                         className="btn btn-sm btn-outline-secondary p-1 copy-btn"
//                                         onClick={() => copyToClipboard(report.paymentReceiveHash, "Receiver Hash ID", receiverHashId)}
//                                         title="Copy Receiver Hash ID"
//                                         style={{ 
//                                           minWidth: '24px',
//                                           minHeight: '24px',
//                                           display: 'flex',
//                                           alignItems: 'center',
//                                           justifyContent: 'center'
//                                         }}
//                                       >
//                                         <MdContentCopy size={14} />
//                                       </button>
//                                       {copiedId === receiverHashId && (
//                                         <div className="copy-tooltip">
//                                           Copied!
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </td>

//                                 <td>
//                                   <span className={`badge ${getStatusBadgeClass(report.paymentStatus)}`}>
//                                     {report.paymentStatus}
//                                   </span>
//                                 </td>
//                                 <td>
//                                   <small>{formatDate(report.createdAt)}</small>
//                                 </td>
//                                 <td>
//                                   <small>
//                                     {report.statusUpdateAt ? formatDate(report.statusUpdateAt) : 'N/A'}
//                                   </small>
//                                 </td>
//                                 <td>
//                                   <small className="">
//                                     {report.paymentComment || 'No comment'}
//                                   </small>
//                                 </td>
//                               </tr>
//                             );
//                           })
//                         ) : (
//                           <tr>
//                             <td colSpan="9" className="text-center py-4">
//                               <i data-lucide="inbox" className="icon-lg  mb-2"></i>
//                               <p className=" mb-0">No payment reports found</p>
//                               <button 
//                                 className="btn btn-sm btn-link mt-2"
//                                 onClick={() => fetchPaymentReports()}
//                               >
//                                 <i className="me-1" data-lucide="refresh-cw"></i> Refresh
//                               </button>
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
//           <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default PaymentReport;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdContentCopy } from "react-icons/md";
import { toast } from 'react-toastify';
import { Search, Filter, Download, Calendar, Eye } from 'lucide-react';
import * as XLSX from 'xlsx';

// Import CSS files
import "../../Dashboard Style/core.css";
import "../../Dashboard Style/flatpickr.min.css";
import "../../assets1/css/custom.css";
import "../../assets1/css/style.css";

import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { getRegisterPaymentListApi } from "../../Services/Operations/ProductAPI";

const PaymentReport = () => {
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [paymentReports, setPaymentReports] = useState([]);
  const [filters, setFilters] = useState({
    date: "",
    month: "",
    year: "",
    status: "",
    payment_mode: ""
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [copiedId, setCopiedId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [isMobile, setIsMobile] = useState(false);

  // Check screen size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      // Auto-close sidebar on mobile by default
      if (mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(true);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);



  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };


  // Add toggle sidebar function
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');

    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }

    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    const initialDropdownState = {
      dashboard: false,
      fundManagement: false,
      registrationTeam: false,
      incomeEarnings: false,
      bonanzaRewards: false,
      airdrop: false,
      withdrawal: false,
      settings: false
    };
    setOpenDropdowns(initialDropdownState);

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
      
      /* Copy button styles */
      .copy-btn {
        transition: all 0.2s ease;
        opacity: 0.7;
      }
      
      .copy-btn:hover {
        opacity: 1;
        transform: scale(1.1);
      }
      
      /* Tooltip for copy feedback */
      .copy-tooltip {
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
        background: #28a745;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 1000;
        animation: fadeInOut 2s ease;
      }
      
      .copy-tooltip:after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #28a745;
      }
      
      @keyframes fadeInOut {
        0% { opacity: 0; transform: translateX(-50%) translateY(5px); }
        20% { opacity: 1; transform: translateX(-50%) translateY(0); }
        80% { opacity: 1; transform: translateX(-50%) translateY(0); }
        100% { opacity: 0; transform: translateX(-50%) translateY(-5px); }
      }
      
      /* Make hash text selectable and clickable */
      .hash-text {
        cursor: pointer;
        transition: color 0.2s ease;
        user-select: none;
      }
      
      .hash-text:hover {
        color: #007bff !important;
      }
      
      /* Responsive adjustments for table */
      @media (max-width: 768px) {
        .table-responsive {
          font-size: 14px;
        }
        
        .copy-btn {
          padding: 2px !important;
          min-width: 20px !important;
          min-height: 20px !important;
        }
      }
      
      /* Payment report specific styles */
      .payment-report-card {
        background: rgba(30, 30, 40, 0.9);
        border-radius: 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      }
      
      .payment-report-table thead th {
        background: linear-gradient(135deg, rgba(13, 110, 253, 0.2) 0%, rgba(102, 126, 234, 0.2) 100%);
        color: #ffffff;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 0.5px;
        padding: 16px 12px;
        border-bottom: 2px solid rgba(13, 110, 253, 0.3);
      }
      
      .payment-report-table tbody td {
        padding: 14px 12px;
        vertical-align: middle;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        color: #e9ecef;
        background: rgba(40, 40, 50, 0.5);
      }
      
      .payment-report-table tbody tr:nth-child(even) td {
        background: rgba(35, 35, 45, 0.5);
      }
      
      .payment-report-table tbody tr:hover td {
        background: rgba(50, 50, 65, 0.7);
      }
      
      /* Filter section */
      .filter-section {
        background: rgba(255, 255, 255, 0.03);
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      /* Summary cards */
      .summary-card-payment {
        background: linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.02) 100%);
        border-radius: 10px;
        padding: 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
      }
      
      .summary-card-payment:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
      }
      
      .summary-card-payment.total-amount {
        border-left: 4px solid #4caf50;
      }
      
      .summary-card-payment.total-count {
        border-left: 4px solid #2196f3;
      }
    `;
    document.head.appendChild(style);

    // Load payment reports
    fetchPaymentReports();

    // Initialize Lucide icons
    if (window.lucide) {
      window.lucide.createIcons();
    }

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Toggle dropdown function
  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const fetchPaymentReports = async (filterParams = {}) => {
    setIsLoading(true);

    try {
      const result = await getRegisterPaymentListApi(authToken, filterParams);

      if (result.status) {
        setPaymentReports(result.data);
        setTotalAmount(result.summary.totalAmount);
        setTotalCount(result.summary.totalCount);

        toast.success(result.message || "Payment reports loaded successfully!");
      } else {
        toast.error(result.message || "Failed to load payment reports");

        // If session expired, redirect to login
        if (result.message.includes('Session expired') || result.message.includes('Unauthorized')) {
          setTimeout(() => {
            navigate('/signin');
          }, 1500);
        }
      }
    } catch (error) {
      console.error("Error fetching payment reports:", error);
      toast.error("Network error. Please check your connection.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    fetchPaymentReports(filters);
  };

  const clearFilters = () => {
    setFilters({
      date: "",
      month: "",
      year: "",
      status: "",
      payment_mode: ""
    });
    setSearchQuery("");
    fetchPaymentReports();
  };

  const exportToExcel = () => {
    if (paymentReports.length === 0) {
      toast.warning("No data to export");
      return;
    }

    const exportData = paymentReports.map(report => ({
      'ID': report.id,
      'Payment Mode': report.payment_mode,
      'Payment Hash ID': report.payment_hash_id,
      'Payment Amount': `$${report.payment_amount}`,
      'Receiver Hash ID': report.payment_receive_hash_id,
      'Status': report.payment_status,
      'Comment': report.payment_comment || 'N/A',
      'Created At': report.created_at,
      'Status Updated At': report.payment_status_update_at || 'N/A'
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payment Reports');
    XLSX.writeFile(wb, `Payment_Reports_${new Date().toISOString().split('T')[0]}.xlsx`);
    toast.success("Report exported to Excel successfully!");
  };

  const exportToPDF = () => {
    if (paymentReports.length === 0) {
      toast.warning("No data to export");
      return;
    }

    toast.info("PDF export feature coming soon!");
  };

  // Enhanced copy function with tooltip feedback
  const copyToClipboard = (text, fieldName = "text", id = null) => {
    if (!text) {
      toast.warning(`No ${fieldName} to copy`);
      return;
    }

    navigator.clipboard.writeText(text)
      .then(() => {
        // Show temporary tooltip
        if (id) {
          setCopiedId(id);
          setTimeout(() => setCopiedId(null), 2000);
        }
        toast.success(`${fieldName} copied to clipboard!`);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        toast.error("Failed to copy to clipboard");
      });
  };

  // Format text for display
  const formatText = (text, maxLength = 20) => {
    if (!text) return 'N/A';
    if (text.length <= maxLength) return text;
    return `${text.substring(0, maxLength)}...`;
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Function to get status badge class
  const getStatusBadgeClass = (status) => {
    if (!status) return 'bg-secondary';

    const statusLower = status.toLowerCase();
    switch (statusLower) {
      case 'approved':
      case 'completed':
      case 'success':
        return 'bg-success';
      case 'pending':
      case 'processing':
        return 'bg-warning text-dark';
      case 'rejected':
      case 'failed':
      case 'cancelled':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  };

  // Filter reports based on search query
  const filteredReports = paymentReports.filter(report => {
    if (!searchQuery.trim()) return true;

    const query = searchQuery.toLowerCase();
    return (
      report.payment_mode?.toLowerCase().includes(query) ||
      report.payment_hash_id?.toLowerCase().includes(query) ||
      report.payment_receive_hash_id?.toLowerCase().includes(query) ||
      report.payment_status?.toLowerCase().includes(query) ||
      report.payment_comment?.toLowerCase().includes(query) ||
      report.payment_amount?.toString().includes(query) ||
      report.id?.toString().includes(query)
    );
  });

  // Get payment mode badge color
  const getPaymentModeBadge = (mode) => {
    if (!mode) return 'bg-secondary';

    const modeLower = mode.toLowerCase();
    if (modeLower.includes('usdt')) return 'bg-success';
    if (modeLower.includes('trc20')) return 'bg-warning text-dark';
    if (modeLower.includes('bep20')) return 'bg-info';
    if (modeLower.includes('erc20')) return 'bg-primary';
    return 'bg-secondary';
  };

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand" onClick={(e) => { e.preventDefault(); navigate('/dashboard'); }}>
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar
          isOpen={!sidebarOpen}
          onClose={closeSidebar}
        />

        {/* Mobile backdrop */}
        {isMobile && sidebarOpen && (
          <div
            className="sidebar-backdrop"
            onClick={closeSidebar}
          />
        )}
      </nav>

      <div className="page-wrapper">
        <Navbar toggleSidebar={toggleSidebar} isSidebarOpen={sidebarOpen}
          isMobile={isMobile} />


        {/* Page Content */}
        <div className="page-content container-xxl">
          {/* Page Header */}
          <div className="row mb-4">
            <div className="col-12">
              <div>
                <h4 className="fw-bold mb-1 text-white">
                  <i className="me-2" data-lucide="file-text"></i>
                  Payment Reports
                </h4>
                <p className="text-muted">View and manage all registration payments</p>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-6">
              <div className="summary-card-payment total-amount">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <i className="bi bi-cash-stack text-success" style={{ fontSize: '2.5rem' }}></i>
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Payment Amount</h6>
                    <h3 className="text-white mb-0">${totalAmount.toFixed(2)}</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="summary-card-payment total-count">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <i className="bi bi-list-check text-info" style={{ fontSize: '2.5rem' }}></i>
                  </div>
                  <div>
                    <h6 className="text-muted mb-1">Total Transactions</h6>
                    <h3 className="text-white mb-0">{totalCount}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filters Section */}
          <div className="filter-section mb-4">
            <h6 className="text-white mb-3">
              <Filter size={18} className="me-2" />
              Filter Payments
            </h6>
            <div className="row g-3">
              <div className="col-md-3">
                <label className="form-label text-white">Date</label>
                <input
                  type="date"
                  className="form-control bg-dark text-white border-secondary"
                  name="date"
                  value={filters.date}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-white">Month</label>
                <select
                  className="form-select bg-dark text-white border-secondary"
                  name="month"
                  value={filters.month}
                  onChange={handleFilterChange}
                >
                  <option value="">All Months</option>
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString('default', { month: 'long' })}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label text-white">Year</label>
                <select
                  className="form-select bg-dark text-white border-secondary"
                  name="year"
                  value={filters.year}
                  onChange={handleFilterChange}
                >
                  <option value="">All Years</option>
                  {Array.from({ length: 5 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return <option key={year} value={year}>{year}</option>;
                  })}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label text-white">Status</label>
                <select
                  className="form-select bg-dark text-white border-secondary"
                  name="status"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Status</option>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
              <div className="col-md-12">
                <div className="d-flex justify-content-between mt-3">
                  <div className="search-box w-50">
                    <Search size={18} className="search-icon text-muted" />
                    <input
                      type="text"
                      className="search-input bg-transparent text-white"
                      placeholder="Search by hash, mode, or amount..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={applyFilters}
                      disabled={isLoading}
                    >
                      {isLoading ? 'Loading...' : 'Apply Filters'}
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={clearFilters}
                      disabled={isLoading}
                    >
                      Clear
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={exportToExcel}
                      disabled={filteredReports.length === 0}
                    >
                      <Download size={16} className="me-2" />
                      Export
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Reports Card */}
          <div className="row">
            <div className="col-12">
              <div className="card payment-report-card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6 className="card-title mb-0 text-white">
                      <i className="me-2" data-lucide="file-text"></i>
                      Registration Payment List
                    </h6>
                    {isLoading && (
                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </div>

                  <div className="table-responsive">
                    <table className="table payment-report-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Payment Mode</th>
                          <th>Payment Hash ID</th>
                          <th>Amount</th>
                          <th>Receiver Hash ID</th>
                          <th>Status</th>
                          <th>Created At</th>
                          <th>Updated At</th>
                          <th>Comment</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td colSpan="10" className="text-center py-5">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <p className="mt-2 text-white">Loading payment reports...</p>
                            </td>
                          </tr>
                        ) : filteredReports.length > 0 ? (
                          filteredReports.map((report, index) => {
                            const paymentHashId = `payment-${report.id}`;
                            const receiverHashId = `receiver-${report.id}`;

                            return (
                              <tr key={report.id}>
                                <td className="text-white fw-bold">{index + 1}</td>
                                <td>
                                  <span className={`badge ${getPaymentModeBadge(report.payment_mode)}`}>
                                    {report.payment_mode}
                                  </span>
                                </td>

                                {/* Payment Hash ID with Copy Button */}
                                <td>
                                  <div className="d-flex align-items-center gap-2 position-relative">
                                    <small
                                      className="hash-text text-white"
                                      title={report.payment_hash_id || 'N/A'}
                                      style={{
                                        wordBreak: 'break-all',
                                        flex: 1,
                                        cursor: 'pointer'
                                      }}
                                      onClick={() => copyToClipboard(report.payment_hash_id, "Payment Hash ID", paymentHashId)}
                                    >
                                      {formatText(report.payment_hash_id, 12)}
                                    </small>
                                    <div className="position-relative">
                                      <button
                                        className="btn btn-sm btn-outline-secondary p-1 copy-btn"
                                        onClick={() => copyToClipboard(report.payment_hash_id, "Payment Hash ID", paymentHashId)}
                                        title="Copy Payment Hash ID"
                                        style={{
                                          minWidth: '24px',
                                          minHeight: '24px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                        }}
                                      >
                                        <MdContentCopy size={14} />
                                      </button>
                                      {copiedId === paymentHashId && (
                                        <div className="copy-tooltip">
                                          Copied!
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <strong className="text-success">${parseFloat(report.payment_amount || 0).toFixed(2)}</strong>
                                </td>

                                {/* Receiver Hash ID with Copy Button */}
                                <td>
                                  <div className="d-flex align-items-center gap-2 position-relative">
                                    <small
                                      className="hash-text text-white"
                                      title={report.payment_receive_hash_id || 'N/A'}
                                      style={{
                                        wordBreak: 'break-all',
                                        flex: 1,
                                        cursor: 'pointer'
                                      }}
                                      onClick={() => copyToClipboard(report.payment_receive_hash_id, "Receiver Hash ID", receiverHashId)}
                                    >
                                      {formatText(report.payment_receive_hash_id, 12)}
                                    </small>
                                    <div className="position-relative">
                                      <button
                                        className="btn btn-sm btn-outline-secondary p-1 copy-btn"
                                        onClick={() => copyToClipboard(report.payment_receive_hash_id, "Receiver Hash ID", receiverHashId)}
                                        title="Copy Receiver Hash ID"
                                        style={{
                                          minWidth: '24px',
                                          minHeight: '24px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                        }}
                                      >
                                        <MdContentCopy size={14} />
                                      </button>
                                      {copiedId === receiverHashId && (
                                        <div className="copy-tooltip">
                                          Copied!
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>

                                <td>
                                  <span className={`badge ${getStatusBadgeClass(report.payment_status)}`}>
                                    {report.payment_status}
                                  </span>
                                </td>
                                <td>
                                  <small className="text-white">{formatDate(report.created_at)}</small>
                                </td>
                                <td>
                                  <small className="text-white">
                                    {report.payment_status_update_at ? formatDate(report.payment_status_update_at) : 'N/A'}
                                  </small>
                                </td>
                                <td>
                                  <small className="text-muted">
                                    {report.payment_comment || 'No comment'}
                                  </small>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-outline-info"
                                    onClick={() => {
                                      // View details action
                                      const details = `
ID: ${report.id}
Payment Mode: ${report.payment_mode}
Amount: $${report.payment_amount}
Payment Hash: ${report.payment_hash_id}
Receiver Hash: ${report.payment_receive_hash_id}
Status: ${report.payment_status}
Comment: ${report.payment_comment || 'None'}
Created: ${formatDate(report.created_at)}
Updated: ${report.payment_status_update_at ? formatDate(report.payment_status_update_at) : 'Not updated'}
      `;
                                      alert(details);
                                    }}
                                    title="View Details"
                                  >
                                    <Eye size={18} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center py-4">
                              <i data-lucide="inbox" className="icon-lg text-muted mb-2"></i>
                              <h5 className="text-white mb-2">No payment reports found</h5>
                              <p className="text-muted mb-3">Try adjusting your filters or search terms</p>
                              <button
                                className="btn btn-primary"
                                onClick={() => fetchPaymentReports()}
                              >
                                <i className="me-1" data-lucide="refresh-cw"></i> Refresh
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer d-flex flex-row align-items-center justify-content-center px-4 py-3 border-top small">
          <p className="text-secondary mb-1 mb-md-0">Copyright © 2025 Willow Quantum. All Right Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default PaymentReport;